import request from "./api";
/**
 *    operationApi   添加实操事项api
 *                         Author by wjl. on 2020.04.13
 *
 * */

// 保存试题事项和答案
export const postQuestionEvent = (params, opts) =>
  request("/api-resource/questionAnswer/saveAnswer", params, {
    ...opts,
    method: "post",
  });

// 新增题干
export const postAddQuestion = (params, opts) =>
  request("/api-resource/questionAnswer/saveMterials", params, {
    ...opts,
    method: "post",
  });

// 修改题干
export const postUpdateQuestion = (params, opts) =>
  request("/api-resource/questionAnswer/updateQuestion", params, {
    ...opts,
    method: "post",
  });

//保存动态参数
export const postAddDynmaic = (params, opts) =>
  request("/api-resource/dynmaicParam/insertOrupdata/dynmaic/param", params, {
    ...opts,
    method: "post",
  });

//获取动态参数
export const getDynmaicById = (str, params, opts) =>
  request(
    "/api-resource/dynmaicParam/get/dynmaic/param/list/" + str,
    params,
    opts
  );

// 修改试题状态 （0普通试题，1 IT试题，IT试题，评分不同）
export const updateQuestionKind = (params, opts) =>
  request("/api-resource/question/updateQuestionKind", params, {
    ...opts,
    method: "post",
  });

//根据科目和标签来获取公司
export const postCompanyByLable = (params, opts) =>
  request("/api-resource/company/query/by/lable", params, {
    ...opts,
    method: "post",
  });

//根据id获取试题详情
export const getQuestionDetail = (id, params, opts) =>
  request(
    "/api-resource/taskEventres/queryDetailByQuestionId/" + id,
    params,
    opts
  );

//id获取试题中的事项
export const getEventTemplateByIds = (ids, params, opts) =>
  request("/api-resource/repeat/eventTemplate/?ids=" + ids, params, opts);

//保存预制数据
export const postAddTemplateData = (params, opts) =>
  request("/api-resource/q_e_json/saveJson", params, {
    ...opts,
    method: "post",
  });
//上传预制数据
export const postImportExcel = (params, opts) =>
  request("/api-resource/q_e_json/importExcel", params, {
    ...opts,
    method: "post",
  });

//网银上传预制数据
export const postBankImportExcel = (params, opts) =>
  request("/api-resource/q_e_json/networkBankParse", params, {
    ...opts,
    method: "post",
  });

//人员信息上传预制数据
export const postPeopleImportExcel = (params, opts) =>
  request("/api-resource/q_e_json/personageTaxParse", params, {
    ...opts,
    method: "post",
  });

//获取预制数据
export const getTemplateData = ({ eventId, questionId }) =>
  request(
    "/api-resource/q_e_json/getJson?eventId=" +
      eventId +
      "&questionId=" +
      questionId
  );
//删除预制数据
export const delTemplateData = (id) =>
  request("/api-resource/q_e_json/removeById/" + id);

//保存spreadjs的ssjson
export const postAddquestionmanuscript = (params) =>
  request("/api-resource/questionmanuscript/save", params, {
    method: "post",
  });

//查询spreadjs的ssjson
export const getquestionmanuscript = (id, params) =>
  request("/api-resource/questionmanuscript/getManuscript/" + id, params);

//删除spreadjs的ssjson
export const delquestionmanuscript = (params) =>
  request("/api-resource/questionmanuscript/delete", params, {
    method: "post",
  });

// 把多个代码块形成一个文件s
export const postRunCoders = (params) =>
  request("/api-resource/code/data/save", params, { method: "post" }); // 把多个代码块形成一个文件s
// 查询之前生成的文件
export const getCodersLog = ({ targetId, targetType }) =>
  request(
    "/api-resource/code/data/getByTargetId?targetId=" +
      targetId +
      "&targetType=" +
      targetType,
    {}
  );
// 删除之前生成的文件
export const deleteCodersLog = (id) =>
  request(
    "/api-resource/code/data/delete/" + id,
    {},
    {
      method: "post",
    }
  );

// 把试题上传到阿里云
export const postUploadOSS = (params) =>
  request("/api-resource/question/uploadQAToOss", params, {
    method: "post",
  });

//获取岗位
export const getMyStation = (courseId, classId, params, opts) =>
  request(
    "/api-course/team/find/myStation/" + courseId + "/" + classId,
    params,
    opts
  );

// 单项训练 单个试题重新评分
export const submitAnswer = (params, opts) =>
  request("/api-score/study/study-end-test", params, {
    ...opts,
    method: "get",
  });

export const submitAnswerstu = (params, opts) =>
  request("/api-score/complex-train-start-score", params, {
    ...opts,
    method: "post",
    contentType: "application/x-www-form-urlencoded",
  });

// 保存评语模板到对应的试题上
export const postRemarkTemplate = (params) =>
    request("/api-resource/remarkTemplate/save", params, {
        method: "post",
    });

// 根据试题id查询评语模板列表
export const findRemarkListByQuestionId = (id) =>
    request("/api-resource/remarkTemplate/findRemarkListByQuestionId?questionId="+ id);

// 查询镜像列表
export const queryImage = (params) =>
  request("/api-image-hub/image/queryImage", params, {
      method: "post",
  });

//   //试题配置查询
// const queryImageCourse = '/api-image-hub/imageCourse/queryImageCourse'
// //试题配置编辑
// const eidtImageCourse = '/api-image-hub/imageCourse/eidtImageCourse'
// //试题配置删除 {id}
// const deleteImageCourse = '/api-image-hub/imageCourse/deleteImageCourse/'
// //试题配置新建
// const saveImageCourse = '/api-image-hub/imageCourse/saveImageCourse'
//查询试题镜像
export const getQusetionImage = (params) =>
  request("/api-image-hub/imageCourse/queryImageCourse", params, {
      method: "post",
  });
//保存试题镜像
export const saveQusetionImage = (params) =>
  request("/api-image-hub/imageCourse/saveImageCourse", params, {
      method: "post",
  });
  //修改试题镜像
export const uodateQusetionImage = (params) =>
request("/api-image-hub/imageCourse/eidtImageCourse", params, {
    method: "post",
});
  //删除试题镜像
  export const deleteQusetionImage = (id) =>
  request("/api-image-hub/imageCourse/deleteImageCourse/" + id, {}, {
      method: "post",
  });
// 获取答题学生的id
export const getStudentId = (params) =>
      request("/api-course/resetExercise/queryResetExercise", params, {
          method: "post",
      });



// WEBPACK FOOTER //
// ./src/api/creatingPracticalTrainingApi.js